import { createTheme } from '@mui/material/styles';
import '@fontsource/public-sans/400.css';

const theme = createTheme({
    palette: {
      primary: {
        main: '#d4af37', // Beige/Gold more elegant
      },
      secondary: {
        main: '#0077b5',
      },
    },
    typography: {
      fontFamily: 'Public Sans, sans-serif',
    },
    
});

export default theme;